import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

import "../forget.scss";
import { Link } from "react-router-dom";

export default function ForgetFormReset({
  initialValues,
  title,
  send,
  error,
  success,
  loading,
}) {
  const [emailVerification, setEmailVerification] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setEmailVerification(false);
    setPasswordValidation(false);

    let emailVerification = new RegExp(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    ).test(values.email);

    if (emailVerification === false) {
      setEmailVerification(true);
    }

    let passwordValidation = new RegExp(
      /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/gm
    ).test(values.senha);

    if (passwordValidation === false) {
      setPasswordValidation(true);
    }

    send(values);
  };

  return (
    <>
      <div className="form-container">
        <div className="welcome-title">
          <h1>
            Seja bem vindo à <b className="text-primary">CTAG</b>
          </h1>
        </div>

        <p className="welcome-info">
          Insira o código recebido por email no campo abaixo
        </p>

        <form onSubmit={handleSubmit}>
          <div className="group-input ">
            <input
              placeholder="E-mail"
              className={`global-input ${
                submitted && !values.email ? "error" : ""
              }`}
              id="email"
              name="email"
              value={values.email}
              onChange={handleChange}
            />

            <div className="error-container">
              {emailVerification && (
                <b className="error-msg">Usuário não encontrado</b>
              )}
            </div>
          </div>

          <div className="group-input">
            <input
              type="password"
              placeholder="Nova Senha"
              className={`global-input ${
                submitted && !values.senha ? "error" : ""
              }`}
              id="senha"
              name="senha"
              value={values.senha}
              onChange={handleChange}
            />

            <div className="error-container">
              {emailVerification && (
                <b className="error-msg">Usuário não encontrado</b>
              )}
            </div>
          </div>

          <div className="group-input">
            <input
              type="password"
              placeholder="Confirmar Senha"
              className={`global-input ${
                submitted && !values.senha ? "error" : ""
              }`}
              id="senha"
              name="senha"
              value={values.senha}
              onChange={handleChange}
            />

            <div className="error-container">
              {emailVerification && (
                <b className="error-msg">Usuário não encontrado</b>
              )}
            </div>
          </div>

          <div className="footer-form-container">
            <span>
              Ou{" "}
              <b>
                <Link to="/login" className="text-dark-light text-decoration-none">
                  Login
                </Link>
              </b>
            </span>

            <button className="global-btn-secondary">
              ENVIAR
              {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
